import type { TFunction } from 'i18next';

import type { FilterDef } from '@nucleus-commerce/admin-kit/index-table';
import {
  PlatformUserRole,
  PlatformUserStatus,
  type PlatformUser,
} from '@nucleus-commerce/api-client/platform';

/** Filters of the platform users table; `t` is the `users` namespace. */
export function userFilters(t: TFunction): Array<FilterDef<PlatformUser>> {
  return [
    {
      key: 'role',
      label: t('columns.role'),
      type: 'enum',
      pinned: true,
      options: Object.values(PlatformUserRole).map((role) => ({
        value: role,
        label: t(`roles.${role}`),
      })),
    },
    {
      key: 'status',
      label: t('columns.status'),
      type: 'enum',
      pinned: true,
      options: Object.values(PlatformUserStatus).map((status) => ({
        value: status,
        label: t(`status.${status}`),
      })),
    },
  ];
}
